export default __webpack_public_path__ + "static/media/chimp.75d01de1.svg";